import { atom } from 'jotai'

export const isLoadingAtom = atom(false)
